"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkStyle = exports.default = exports.ChangePasswordComponent = exports.A = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const {
  colours
} = _uiKit.theme;
const linkStyle = exports.linkStyle = (0, _styledComponents.css)(["transition:color 300ms;color:", ";text-decoration:none;&:hover{color:", ";text-decoration:none;cursor:pointer;}"], colours.WHITE, colours.WHITE);
const A = exports.A = _styledComponents.default.a.withConfig({
  displayName: "ChangePassword__A",
  componentId: "sc-wak2sz-0"
})(["", ";"], linkStyle);
const ChangePasswordComponent = _ref => {
  let {
    onFocus,
    onBlur,
    openModal,
    ...rest
  } = _ref;
  const handleClick = e => {
    if (openModal) {
      openModal();
      e.preventDefault();
    }
  };
  // @ts-ignore
  return /*#__PURE__*/_react.default.createElement(A, Object.assign({}, rest, {
    onClick: handleClick,
    onFocus: onFocus,
    onBlur: onBlur
  }));
};
exports.ChangePasswordComponent = ChangePasswordComponent;
var _default = exports.default = ChangePasswordComponent;